package ru.dinarastepina.fabvocab.contracts

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
sealed interface ExerciseDto {
    val wordId: String

    @Serializable
    @SerialName("fill_blank")
    data class FillBlankDto(
        override val wordId: String = "",
        val sentence: String,
        val answer: String,
        val hint: String? = null,
    ) : ExerciseDto

    @Serializable
    @SerialName("definition_match")
    data class DefinitionMatchDto(
        override val wordId: String = "",
        val word: String,
        val options: List<String>,
        val correctIndex: Int,
    ) : ExerciseDto

    @Serializable
    @SerialName("true_false")
    data class TrueFalseDto(
        override val wordId: String = "",
        val sentence: String,
        val isCorrectUsage: Boolean,
        val explanation: String? = null,
    ) : ExerciseDto
}
